import { FormFieldWidget, FormO2MTableFieldWidget, ModelFieldType, SPI, ViewType } from "@kunlun/dependencies";
import { createVNode, defineComponent } from "vue";

const node = defineComponent({
    render() { 
        return createVNode('div')
    }
})


@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: [ViewType.Form],
        ttype: ModelFieldType.OneToMany,
        name: 'createOrderSaleSkuList',
        widget: 'Table',
        model: 'deli.aries.seller.deliAriesOrderPartCancelParam',
        multi: true
    })
)
export class FormOrderItemDetailWidget extends FormO2MTableFieldWidget { 
    initialize(props: any): this {
        super.initialize(props)
        this.setComponent(node)
        return this
    }
}